(function () {
  'use strict';

  var impressed = new WeakSet();

  function dispatchFrictionEvent(detail) {
    if (!detail || !detail.module || !detail.action) return;
    document.dispatchEvent(new CustomEvent('rr:friction-fix', { detail: detail }));
  }

  function parseHtml(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  function buildPageSections() {
    if (typeof CartSectionRegistry !== 'undefined') {
      return CartSectionRegistry.getSections();
    }

    var sections = [];
    var mainCartItems = document.getElementById('main-cart-items');
    var mainCartFooter = document.getElementById('main-cart-footer');
    if (mainCartItems) {
      sections.push({ id: 'main-cart-items', section: mainCartItems.dataset.id, selector: '.js-contents' });
    }
    if (mainCartFooter) {
      sections.push({ id: 'main-cart-footer', section: mainCartFooter.dataset.id, selector: '.js-contents' });
    }
    sections.push({ id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' });
    sections.push({ id: 'cart-live-region-text', section: 'cart-live-region-text', selector: '.shopify-section' });
    return sections;
  }

  function renderRegisteredSections(sectionsHtml, sectionsToRender) {
    if (!sectionsHtml) return;

    for (var i = 0; i < sectionsToRender.length; i += 1) {
      var section = sectionsToRender[i];
      var container = document.getElementById(section.id);
      if (!container || !sectionsHtml[section.section]) continue;

      var target = section.selector ? container.querySelector(section.selector) : container;
      var source = parseHtml(sectionsHtml[section.section], section.selector || '.shopify-section');
      if (!target || !source) continue;
      target.innerHTML = source.innerHTML;
    }
  }

  function getAddContext() {
    var cartSurface = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    if (cartSurface && typeof cartSurface.getSectionsToRender === 'function') {
      return {
        cartSurface: cartSurface,
        requestSectionIds: cartSurface.getSectionsToRender().map(function (section) {
          return section.id;
        }),
        renderSections: null,
      };
    }

    var pageSections = buildPageSections();
    return {
      cartSurface: null,
      requestSectionIds: pageSections.map(function (section) {
        return section.section;
      }),
      renderSections: pageSections,
    };
  }

  function setLoadingState(root, loading) {
    var addBtn = root.querySelector('.cart-addon-item__add-btn');
    var addText = root.querySelector('.cart-addon-item__add-text');
    var addingText = root.querySelector('.cart-addon-item__adding-text');
    if (addBtn) addBtn.disabled = loading;
    if (addText) addText.hidden = loading;
    if (addingText) addingText.hidden = !loading;
  }

  function showError(root, message) {
    var errorText = root.querySelector('.cart-addon-item__error-text');
    if (!errorText) return;
    errorText.textContent = message || 'Unable to add item to cart.';
    errorText.hidden = false;
    window.setTimeout(function () {
      errorText.hidden = true;
      errorText.textContent = '';
    }, 3000);
  }

  function trackThresholdImpressions() {
    var modules = document.querySelectorAll('[data-threshold-state]');
    for (var i = 0; i < modules.length; i += 1) {
      var module = modules[i];
      if (impressed.has(module)) continue;
      impressed.add(module);
      dispatchFrictionEvent({
        module: 'cart-threshold',
        surface: 'cart',
        action: 'view',
        thresholdRemainingCents: Number(module.getAttribute('data-threshold-remaining-cents') || '0')
      });
    }
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.cart-addon-item__add-btn');
    if (!button) return;

    var item = button.closest('.cart-addon-item');
    if (!item) return;

    event.preventDefault();
    setLoadingState(item, true);

    var errorText = item.querySelector('.cart-addon-item__error-text');
    if (errorText) {
      errorText.hidden = true;
      errorText.textContent = '';
    }

    var addContext = getAddContext();
    var variantId = button.getAttribute('data-variant-id') || item.getAttribute('data-variant-id') || '';
    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');
    if (addContext.requestSectionIds.length) {
      formData.append('sections', addContext.requestSectionIds.join(','));
      formData.append('sections_url', window.location.pathname);
    }
    if (addContext.cartSurface && typeof addContext.cartSurface.setActiveElement === 'function') {
      addContext.cartSurface.setActiveElement(document.activeElement);
    }

    var config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = formData;

    fetch(routes.cart_add_url, config)
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        if (response.status) {
          throw new Error(response.message || response.description || 'Unable to add item to cart.');
        }

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'cart-addon',
          productVariantId: variantId,
          cartData: response,
          mutation: 'add',
        });

        if (addContext.cartSurface && typeof addContext.cartSurface.renderContents === 'function') {
          addContext.cartSurface.renderContents(response);
        } else if (addContext.renderSections) {
          renderRegisteredSections(response.sections, addContext.renderSections);
        }

        dispatchFrictionEvent({
          module: 'cart-recommendations',
          surface: 'cart',
          action: 'add',
          variantId: Number(variantId || '0')
        });
      })
      .catch(function (error) {
        showError(item, error.message);
      })
      .finally(function () {
        setLoadingState(item, false);
      });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', trackThresholdImpressions);
  } else {
    trackThresholdImpressions();
  }

  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(trackThresholdImpressions).observe(document.body, { childList: true, subtree: true });
  }
})();
